import { WorkspaceBoardCard } from './WorkspaceBoardCard.jsx'
import { Badge } from "/src/modern/components/ui/badge.tsx"
import { Button } from "/src/modern/components/ui/button.tsx"

export function RecentlyViewedSection({ recentItems, onWorkforceActiveChange, onBoardAccess }) {
  if (recentItems.length > 0) {
    return (
      <div className="space-y-swivu-vertical-base">
        {/* Section Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <i className="fa fa-clock text-swivu-icon text-muted-foreground" />
            <h2 className="text-swivu-lg font-semibold text-foreground">Recently Viewed</h2>
            <Badge variant="secondary" size="lg">
              {recentItems.length}
            </Badge>
          </div>
        </div>

        <p className="text-muted-foreground text-swivu-base mb-swivu-base">Quick access to your most recently viewed boards</p>

        {/* Recent Items Grid */}
        <div className="grid lg:grid-cols-2 xl:grid-cols-4 gap-swivu-base">
          {recentItems.slice(0, 6).map((item) => (
            <div key={item.id} className="relative">
              <WorkspaceBoardCard
                board={item.boardData}
                onWorkforceActiveChange={onWorkforceActiveChange}
                onBoardAccess={onBoardAccess}
              />
            </div>
          ))}
        </div>

        {/* Show More Button for Mobile */}
        {recentItems.length > 3 && (
          <div className="lg:hidden flex justify-center">
            <Button variant="outline" size="sm">
              Show More Recent Boards
            </Button>
          </div>
        )}
      </div>
    )
  }
}
